import { ElectronicInvoiceAddress } from 'src/modules/invoice/models/electronicInvoiceAddress';
import { ElectronicInvoiceAddressPost, ElectronicInvoiceAddressPut } from 'src/modules/invoice/models/electronicInvoiceAddressRequest';
import { EInvoiceAddressSearchFilter } from 'src/modules/invoice/models/eInvoiceAddressSearchFilter';
import { PagedResult } from '../models/pagedResult';
import AxiosInstance from './axios/interceptor';
import { setPagingParams } from '../functions/createPagingParams';

const controller = 'ElectronicInvoiceAddress';

export const getAllElectronicInvoiceAddresses = (searchFilter: EInvoiceAddressSearchFilter, pendingOnly = false, isOther?: boolean) => {
  const pageIndex = searchFilter?.pageIndex ?? 0;
  const pageSize = searchFilter?.pageSize ?? 50;
  const sortCol = searchFilter?.sortCol ?? 'eInvoiceAddress_id';
  const sortDir = searchFilter?.sortDir ?? 'desc';

  let extraQuery = '';
  extraQuery += searchFilter?.filter ? `&filter=${searchFilter.filter}` : '';
  if (pendingOnly) extraQuery += '&PendingOnly=true';
  if (isOther !== undefined) extraQuery += `&IsOther=${isOther}`;

  const endpoint = `${controller}/?${setPagingParams({ pageIndex, pageSize, sortCol, sortDir })}${extraQuery}`;
  return AxiosInstance.get<PagedResult<ElectronicInvoiceAddress>>(endpoint);
};

export const getElectronicInvoiceAddressById = (id: number) => {
  return AxiosInstance.get<ElectronicInvoiceAddress>(`${controller}/${id}`);
};

export const createElectronicInvoiceAddress = (data: ElectronicInvoiceAddressPost) => {
  return AxiosInstance.post<ElectronicInvoiceAddressPost>(controller, data);
};

export const updateElectronicInvoiceAddress = (data: ElectronicInvoiceAddressPut) => {
  return AxiosInstance.put<ElectronicInvoiceAddressPut>(controller, data);
};

export const deleteElectronicInvoiceAddress = (id: number) => {
  return AxiosInstance.delete(`${controller}/${id}`);
};

export const hasLinkedEInvoiceAddress = (memberId: number) => {
  const endpoint = `${controller}/?${setPagingParams({
    pageIndex: 0,
    pageSize: 1,
    sortCol: 'eInvoiceAddress_id',
    sortDir: 'desc',
  })}&MemberId=${memberId}`;
  return AxiosInstance.get<PagedResult<ElectronicInvoiceAddress>>(endpoint).then((res) => res.data.totalItems > 0);
};
